/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Node } from 'react';

import React from 'react';
import ProvenancePopover from './ProvenancePopover/index.js';
import { chip } from './AiFieldMarking.module.scss';

type Props = {|
  aiStatus: 'none' | 'proposed' | 'accepted',
  provenance: ?Object,
  fieldId: string,
|};

const CHIP_TEXT = 'SP3-AI';

/*
 * The label-row decoration for an AI-marked field (UI design §3.1): a small chip naming
 * the marking, plus the provenance affordance (§3.3). The chip is uniform across proposed
 * and accepted -- the field's *state* is conveyed by its controls (Accept/Reject vs Edit),
 * not by the chip's text or color. Rendered alongside the field's own label -- the field's
 * row is otherwise unchanged.
 */
const AiFieldMarking = ({ aiStatus, provenance, fieldId }: Props): Node =>
  aiStatus === 'none' ? null : (
    <span className={`${chip} ai-generated-chip`}>
      {CHIP_TEXT}
      <ProvenancePopover provenance={provenance} fieldId={fieldId} />
    </span>
  );

export default AiFieldMarking;
